// --- Dependencies
import React from 'react';
// --- Styles
import styles from './layout-two-rows.module.scss';

/**
 * TwoRowsLayout Component
 *
 * This functional component acts as a layout wrapper that organizes its children into two rows.
 * It applies styles from `styles.container` to ensure proper structure and appearance.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {React.ReactNode} props.children - Elements to be wrapped inside the two-row layout.
 */
const TwoRowsLayout = ({ children }) => <section className={styles.container}>{children}</section>;

export default TwoRowsLayout;
